import {isEditor} from '../../../../../../commons/selectors/environment'
import {getRibbonData} from '../../../selectors/events'
import {isItemOpened} from '../../../selectors/layout'
import {AppProps} from '../../app/interfaces'
import {connect} from '../../runtime-context/connect'
import {isMembersInstalled, isMembersVisible} from '../../../selectors/settings'
import {Card as CardPresentation} from './card'
import {CardOwnProps, CardStateProps} from './interfaces'

const mapRuntime = ({state, host: {dimensions}}: AppProps, {event}: CardOwnProps): CardStateProps => {
  return {
    showMembers: isMembersVisible(state, event),
    membersEnabled: isMembersInstalled(state),
    hasRibbon: getRibbonData(state, event).visible,
    editor: isEditor(state),
    expanded: isItemOpened(state, event.id),
    compId: state.component.id,
  }
}

export const Card = connect<CardOwnProps, CardStateProps>(mapRuntime)(CardPresentation)

export * from './interfaces'
